import { classMerge } from '../../utils/classMerge'
import { afField } from '@autodromo/contextual-fields';
import { CardContainer, GalleryWithTabsImage, TextCard, TextContainer } from './GalleryWithTabs.styles'
import { formatGtagLabel } from '../../utils/formatGtagLabel'
import { ConditionalImageWrapper } from '../../components/ConditionalImageWrapper'

export type CardProps<T> = {
  isActive?: boolean
  id?: string | number
  fieldPath?: string | null
  image: {
    render: (props: T) => JSX.Element
    props: T
  }
  openLinkInNewTab?: boolean;
  link?: string;
  title: string
  className?: string
  htmlId?: string
}

type FinalCardProps<T> = CardProps<T> & { 
  bgColor: string
  textColor: string
  galleryTitle?: string
  cardIndex?: number
}

export const Card = <T,>({
  fieldPath,
  image,
  title,
  bgColor,
  className,
  textColor,
  galleryTitle,
  cardIndex,
  openLinkInNewTab,
  link,
  htmlId
}: FinalCardProps<T>) => {
  return (
    <CardContainer
      className={classMerge(className)}
      data-testid='card'
    >
      <GalleryWithTabsImage
        data-af-field={afField(fieldPath, 'image', 'props', 'src')}
        data-gtag-action='Clique Imagem'
        data-gtag-category='Galeria com Abas'
        data-gtag-label={formatGtagLabel(htmlId, galleryTitle, `Card ${(cardIndex || 0) + 1}`, link)}
      >
        <ConditionalImageWrapper<T>
          image={image}
          href={link}
          openInNewTab={openLinkInNewTab}
        />
      </GalleryWithTabsImage>
      <TextContainer bgColor={bgColor}>
        <TextCard
          style={{ color: textColor }}
          textColor={textColor}
          data-testid='card-title'
          data-af-field={afField(fieldPath, 'title')}
        > {title}</TextCard>
      </TextContainer>
    </CardContainer>
  )
}
